/**
 * Transaction actions
 */
export enum TransactionActionEnum {
	/**
	 * Set transaction status to completed (non-payment-bearing types only)
	 */
	COMPLETE = 'complete',

	/**
	 * Set transaction status to cancelled
	 */
	CANCEL = 'cancel',

	/**
	 * Refund the payment linked to the transaction
	 */
	REFUND = 'refund',

	/**
	 * Capture an authorized payment or refund
	 */
	CAPTURE = 'capture',

	/**
	 * Send payment link for manual payment-bearing transaction
	 */
	SEND_PAYMENT_LINK = 'send_payment_link',
}
